import { render, staticRenderFns } from "./flag-icon.vue?vue&type=template&id=7af2900f"
import script from "./flag-icon.vue?vue&type=script&lang=js"
export * from "./flag-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports